export const selectedPlanSelector = (state) => state.global.onboarding.selectedPlan;



// WEBPACK FOOTER //
// ./src/state/modules/global/selectors.js